import { render, staticRenderFns } from "./WishlistBadge.vue?vue&type=template&id=bd24bba2&"
import script from "./WishlistBadge.vue?vue&type=script&lang=ts&"
export * from "./WishlistBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports